import type { ReactNode } from 'react';

/** The title block every page starts with, so they all start the same way. */
export function PageHeader({
  title,
  description,
  actions,
}: {
  title: string;
  description?: string;
  actions?: ReactNode;
}) {
  return (
    <div className="page-header">
      <div>
        <h1 className="page-header__title">{title}</h1>
        {description !== undefined && <p className="page-header__description">{description}</p>}
      </div>
      {actions !== undefined && <div className="page-header__actions">{actions}</div>}
    </div>
  );
}

/**
 * A titled block within a page.
 *
 * `actions` sit in the header, to the right of the title, as a page's do in
 * `PageHeader`: an action about one card belongs on that card rather than at
 * the top of the page, where it reads as being about all of them.
 */
export function Panel({
  title,
  description,
  actions,
  children,
}: {
  title: string;
  description?: string;
  actions?: ReactNode;
  children: ReactNode;
}) {
  const heading = (
    <>
      <h2 className="panel__title">{title}</h2>
      {description !== undefined && <p className="panel__description">{description}</p>}
    </>
  );
  return (
    <section className="panel" aria-label={title}>
      {actions === undefined ? (
        heading
      ) : (
        <div className="panel__header">
          <div>{heading}</div>
          <div className="panel__header-actions">{actions}</div>
        </div>
      )}
      <div className="panel__body">{children}</div>
    </section>
  );
}
